
const styles = theme =>({

    formBuilderCustomise: {
        '& .preview_templates':{
            zIndex: '1111 !important',
             '& .preview_templates_Wrapper':{
                    maxWidth:'720px !important',
                    height:'80%',
                    overflow:'auto',
             },
        },  
        '& .react-form-builder': {
            width: '100%',
            display: 'block',
            '&  > div:first-child': {
                boxSizing: 'border-box',
                display: 'grid',
                gridTemplateColumns: '70% 1fr',
                alignItems: 'flex-start',
                gap: '1rem'
            },
            '& .react-form-builder-preview': {
                boxSizing: 'border-box',
                boxShadow: 'none',
                background: '#fff',
                '& .edit-form':{
                    '& .formrating':{
                        paddingBottom:'10rem'
                    }
                }
            },
            '& .react-form-builder-toolbar': {
                marginTop: '0',
                position: 'sticky',
                top: '10px'
            },
            '& .toolbar-header-buttons': {
                display: 'flex',
                gap: '1rem'
            },
            '& .rfb-item.SortableItem .form-group select': {
                padding: '8px'
            },
            '& .rfb-item.SortableItem .label-required': {
                color: 'red',
                padding: '2px'
            }

        },
        '& .react-form-builder-form': {
            '& .rfb-item.SortableItem .form-group select': {
                padding: '8px'
            },
            '& .rfb-item.SortableItem .label-required': {
                color: 'red',
                padding: '2px'
            }

        }
    },
    
    '& .react-form-builder-form': {
        '& .rfb-item.SortableItem .form-group select': {
            padding: '8px'
        },
        '& .label-required': {
            color: 'red',
            padding: '2px'
        }
    },

    '& .MuiDialogContent-root': {

        '& .validation-error': {
            position: 'relative !important'
        },
        '& .react-form-builder-form': {
            '& .rfb-item.SortableItem .form-group select': {
                padding: '8px'
            },
            '& .rfb-item.SortableItem .label-required': {
                color: 'red',
                padding: '2px'
            }
        }
    },


    heading:{
        color: '#333333',
        margin: '0px 0px 16px 0px',
        fontSize: '2rem',
        fontFamily:' VodafoneRg-Regular',
        fontWeight: '400',
        lineHeight: 1
      },
      viewlink:{
        backgroundColor:'#e60000',
        border:'1px solid #e60000',
        color:'#fff',
        // width: '100%',
        display: 'block',
        padding: '1rem',
        'box-sizing': 'border-box',
        textAlign: 'center',
        fontSize: '1rem',
        fontFamily: "VodafoneRg-Regular",
        borderRadius:'5px',
        transition:'all 300ms ease',
        marginTop:'2rem',
        '&:hover':{
          background:'transparent',
          border:'1px solid #e60000',
          color:'#333'
        },
        '&:disabled':{
            opacity:0.3,
            'pointer-events':'none'
          }
      },
      

})
export default styles